export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-record-8db2a7abf6e0f1f40150d17aa98cabea.svg";